import { ToolResult } from '../../types/tool.types';
import { ToolContext } from '../tool-context.type';

export async function highlightObject(args: any, context: ToolContext): Promise<ToolResult> {
	const { threeInstance, publish } = context;
	if (!threeInstance) {
		return { success: false, error: 'Three.js instance not initialized' };
	}

	const { objectId, addHighlight } = args;
	// console.log('highlight-object.tool: Received args', { objectId, addHighlight, args });
	if (typeof objectId !== 'string') {
		return { success: false, error: 'objectId parameter must be a string' };
	}

	// addHighlight is optional - defaults to false (switch mode)
	const shouldAddHighlight = Boolean(addHighlight);
	// console.log('highlight-object.tool: Calling highlightObject', { objectId, shouldAddHighlight });
	threeInstance.highlightObject(objectId, shouldAddHighlight);
	
	publish('object', 'highlighted', {
		ref: objectId,
		old: null,
		new: null
	});

	return { success: true, data: { objectId }};
}
